<template>
  <div
    :class="`content-container ${
      isSupportChatOpened
        ? isChatWidgetOpened
          ? 'container-with-chat-opened'
          : 'container-with-chat-closed'
        : 'float-content-container'
    } ${contentStateClass} elevation-6`"
  >
    <v-row
      class="pt-3 mt-0 mr-0 mb-2"
      style="
        min-width: 100%;
        position: sticky;
        top: 0px;
        background-color: white;
        z-index: 1;
      "
    >
      <v-btn icon @click="$emit('back')">
        <v-icon size="30px">ph-caret-left</v-icon>
      </v-btn>
      <v-spacer />
      <v-btn icon @click="isExpanded = !isExpanded" class="cursor-pointer">
        <v-icon size="33px">{{ toggleIcon }}</v-icon>
      </v-btn>
    </v-row>

    <main class="main-content">
      <h2 class="content-title">{{ item.title }}</h2>

      <p class="content-subtitle mt-2">
        {{ item.description }}
      </p>

      <v-card-text class="pa-0" style="font-size: 14px">
        <div v-if="item.steps && item.steps.length">
          <component
            v-for="(step, index) in item.steps"
            :key="`step-${index}`"
            :is="step.is"
            v-bind="step.bind"
            v-on="step.on"
            class="mt-4"
            style="overflow-wrap: break-word"
          >
            {{ step.inner }}
            <component
              v-for="(innerStep, jindex) in step.elements"
              :key="`step-${index}-${jindex}`"
              :is="innerStep.is"
              v-bind="innerStep.bind"
              v-on="innerStep.on"
              class="mt-4"
              style="overflow-wrap: break-word"
            >
              {{ innerStep.inner }}
            </component>
          </component>
        </div>
        <div
          class="mt-6"
          style="
            display: flex;
            flex-direction: row;
            justify-content: space-between;
          "
          v-if="item.onboardingName"
        >
          <v-btn
            color="#8165d1"
            class="text-none text-body-1 font-weight-medium"
            elevation="0"
            outlined
            :loading="loading"
            :disabled="loading || isItemCompleted"
            @click="handleCompleteOnboarding(item)"
            v-if="!isItemCompleted && !hideCompleteButton"
          >
            {{ $t("guide.stepsOnboarding.understandOnboardingButton") }}
          </v-btn>
          <v-btn
            v-if="showNavigateButton"
            color="#8165d1"
            class="text-none text-body-1 font-weight-medium white--text"
            elevation="0"
            :disabled="loading"
            @click="navigateTo(item)"
          >
            {{ $t("guide.stepsOnboarding.buttonLabel") }}
          </v-btn>
        </div>
      </v-card-text>
    </main>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
export default {
  name: "CustomDetailContent",
  props: {
    item: {
      type: Object,
      required: true,
    },
    isItemCompleted: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideCompleteButton: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      isExpanded: false,
      loading: false,
    };
  },
  computed: {
    ...mapGetters(["isSupportChatOpened", "isChatWidgetOpened", "currentUser"]),

    contentStateClass() {
      return this.isExpanded ? "expanded" : "collapsed";
    },

    toggleIcon() {
      return this.isExpanded ? "ph-arrows-in-simple" : "ph-arrows-out-simple";
    },

    showNavigateButton() {
      const routeName = this.$route?.name;
      const nextRouteName = this.item?.nextRouteName;
      return !nextRouteName || routeName != nextRouteName;
    },
  },
  methods: {
    ...mapActions(["completeUserOnboarding"]),
    ...mapMutations(["setSnackBar"]),

    async handleCompleteOnboarding(item) {
      const onboarding_code = item.onboarding_code || item.onboardingName;
      this.loading = true;

      try {
        await this.completeUserOnboarding(onboarding_code);

        this.setSnackBar({
          show: true,
          message: `Onboarding "${item.title}" concluído!`,
          color: "success",
        });
      } catch (error) {
        console.error("Error completing onboarding:", error);

        this.setSnackBar({
          show: true,
          message: "Erro ao concluir onboarding. Tente novamente.",
          color: "error",
        });
      } finally {
        this.loading = false;
      }
    },

    navigateTo(item) {
      if (item.buttonUrl) {
        window.open(item.buttonUrl);
        return;
      }

      const target = { name: item.nextRouteName };

      if (item.nextRouteName === "User" && this.currentUser?.id_google) {
        target.query = {
          id: this.currentUser.id_google,
          guideOnboarding: item.onboarding_code,
        };

        switch (item.onboarding_code) {
          case "email_aliases":
            target.query.open = "alias";
            break;
          case "secondary_emails":
            target.query.open = "sendas";
            break;
          case "drive_sharing":
            target.query.open = "sharedDrives";
            break;
          case "email_delegation":
            target.query.open = "delegate";
            break;
          default:
            break;
        }
      }

      if (this.$route.name !== item.nextRouteName || target.query) {
        this.$router.push(target);
      }
    },
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.content-container {
  display: flex;
  flex-direction: column;

  font-family: "Poppins", sans-serif;
  z-index: 9999;
  background-color: rgb(255, 255, 255);
  max-height: 80%;

  padding: 0 22px 0;
  text-align: start;
  border-radius: 14px;
  overflow: auto;
}

.expanded {
  width: 900px;
  max-width: 900px;
}

.collapsed {
  max-width: 430px;
}

.float-content-container {
  position: fixed;
  bottom: 8%;
  right: 20px;
}

.container-with-chat-opened {
  position: fixed;
  bottom: 9%;
  right: 400px;
}

.container-with-chat-closed {
  position: fixed;
  bottom: 9%;
  right: 90px;
}

.content-container {
  scrollbar-color: #888 #f0f0f0;
  scrollbar-width: thin;
}

.main-content {
  padding: 13px 9px 22px 26px;
  font-family: "Poppins", sans-serif;
}

.content-title {
  font-size: 18px;
  font-weight: 700;
  color: black;
  font-family: "Poppins", sans-serif;
}

.content-subtitle {
  font-size: 14px;
  color: #807e7e;
  font-weight: 500;
  margin-bottom: 22px;
}

.content-container ol {
  padding-left: 16px;
  color: black;
}

.content-container li {
  color: black;
  font-size: 14px;
}

.elevation-6 {
  box-shadow: 0px 6px 6px -3px rgba(0, 0, 0, 0.2),
    0px 10px 14px 1px rgba(0, 0, 0, 0.14), 0px 4px 18px 3px rgba(0, 0, 0, 0.12);
}
</style>
